import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { DurationPickerComponent } from '../../../../../../shared/components/duration-picker/duration-picker.component';
import {
	dateCast,
	toDateString,
} from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRoadTaxRecordModel } from '../../../models/vehicle-road-tax-record.model';
import { ROAD_TAX_RECORD_CATEGORIES } from '../../../translations/vehicle-road-taxes-select-items';

@Component({
	selector: 'app-vehicle-road-taxes-details',
	templateUrl: 'vehicle-road-taxes-details.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SectionWrapperComponent,
		DurationPickerComponent,
	],
})
export class VehicleRoadTaxesDetailsComponent
	extends BaseSectionComponent<VehicleRoadTaxRecordModel>
	implements OnInit
{
	protected _skipCount: number = 0;
	recordCategories = ROAD_TAX_RECORD_CATEGORIES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			code: [null],
			externalReference: [null],
			startsAt: [null],
			endsAt: [null],
			totalNet: [null],
			totalTax: [null],
			totalGross: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			code: this.recordData().code,

			externalReference: this.recordData().externalReference,
			startsAt: toDateString(this.recordData().startsAt),
			endsAt: toDateString(this.recordData().endsAt),
			totalNet: this.recordData().totalNet,
			totalTax: this.recordData().totalTax,
			totalGross: this.recordData().totalGross,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRoadTaxRecordModel> {
		return {
			code: this.detailsForm.value.code,

			externalReference: this.detailsForm.value.externalReference,
			startsAt: dateCast(this.detailsForm.value.startsAt),
			endsAt: dateCast(this.detailsForm.value.endsAt),
			totalNet: this.detailsForm.value.totalNet,
			totalTax: this.detailsForm.value.totalTax,
			totalGross: this.detailsForm.value.totalGross,
		};
	}
}
